<section class="detail-banner">
    <div class="icon">
        <i class="icon-info"></i>
    </div>
    <div class="banner-content">
        <ng-container *ngFor="let item of bannerData.paragraphs">
            <ng-container [ngSwitch]="item.type">
                <p *ngSwitchCase="'text'">{{item.text}}</p>
                <button class="iona-button white" *ngSwitchCase="'button'"
                        (click)="onBannerInteraction(item.buttonId)">
                    {{item.buttonText}}
                    <i class="chevron-right-s"></i>
                </button>
            </ng-container>
        </ng-container>
    </div>
    <ng-container *ngIf="bannerData.sideButton.visible">
        <div class="close">
            <ng-container *ngIf="bannerData.sideButton.isClose ; else altSideBtn">
                <button class="iona-icon-only-button close" (click)="onSideButtonInteraction()"> </button>
            </ng-container>
            <ng-template #altSideBtn>
                <button class="iona-icon-only-button next" (click)="onSideButtonInteraction()"> </button>
            </ng-template>
        </div>
    </ng-container>
</section>
